module.exports = __webpack_public_path__ + "static/media/management.98ffd29d.svg";